import React, { useState } from 'react'
import { ActionButton } from '@contrast-security-inc/design-system-actions'
import type { ConfirmationActionProps } from '../../types/confirmationRoleAction'

export const ConfirmationAction = ({
  icon,
  iconTooltipMessage,
  iconTooltipPlacement,
  renderDialog,
  iconMetadata,
  pendoId,
  hideTooltip = false,
  size = 'sm',
  isDisabled,
  testId,
  ...rest
}: ConfirmationActionProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleActionClick = () => setIsOpen(true)
  const handleCloseDialog = () => setIsOpen(false)

  return (
    <>
      <ActionButton
        {...rest}
        TooltipProps={{
          enabled: !hideTooltip,
          placement: iconTooltipPlacement,
          body: iconTooltipMessage
        }}
        IconButtonProps={{
          Icon: icon,
          size,
          'aria-label': iconTooltipMessage
        }}
        onClick={handleActionClick}
        metadata={iconMetadata}
        testId={testId}
        data-pendo={pendoId}
        isDisabled={isDisabled}
      />
      {isOpen && renderDialog({ isOpen, closeDialog: handleCloseDialog })}
    </>
  )
}
